export const data = [
  {
    "id": "AFG",
    "value": 367170
  },
  {
    "id": "AGO",
    "value": 915297
  },
  {
    "id": "ALB",
    "value": 111284
  },
  {
    "id": "ARE",
    "value": 168006
  },
  {
    "id": "ARG",
    "value": 900496
  },
  {
    "id": "ARM",
    "value": 414355
  },
  {
    "id": "ATA",
    "value": 243107
  },
  {
    "id": "ATF",
    "value": 670358
  },
  {
    "id": "AUT",
    "value": 386231
  },
  {
    "id": "AZE",
    "value": 531415
  },
  {
    "id": "BDI",
    "value": 766774
  },
  {
    "id": "BEL",
    "value": 291922
  },
  {
    "id": "BEN",
    "value": 518191
  },
  {
    "id": "BFA",
    "value": 746409
  },
  {
    "id": "BGD",
    "value": 936879
  },
  {
    "id": "BGR",
    "value": 269519
  },
  {
    "id": "BHS",
    "value": 316763
  },
  {
    "id": "BIH",
    "value": 114155
  },
  {
    "id": "BLR",
    "value": 420507
  },
  {
    "id": "BLZ",
    "value": 271460
  },
  {
    "id": "BOL",
    "value": 226756
  },
  {
    "id": "BRN",
    "value": 482294
  },
  {
    "id": "BTN",
    "value": 971606
  },
  {
    "id": "BWA",
    "value": 370787
  },
  {
    "id": "CAF",
    "value": 333755
  },
  {
    "id": "CAN",
    "value": 784300
  },
  {
    "id": "CHE",
    "value": 153608
  },
  {
    "id": "CHL",
    "value": 485208
  },
  {
    "id": "CHN",
    "value": 460477
  },
  {
    "id": "CIV",
    "value": 886216
  },
  {
    "id": "CMR",
    "value": 609718
  },
  {
    "id": "COG",
    "value": 489530
  },
  {
    "id": "COL",
    "value": 987587
  },
  {
    "id": "CRI",
    "value": 617602
  },
  {
    "id": "CUB",
    "value": 237148
  },
  {
    "id": "-99",
    "value": 962567
  },
  {
    "id": "CYP",
    "value": 296600
  },
  {
    "id": "CZE",
    "value": 497874
  },
  {
    "id": "DEU",
    "value": 521390
  },
  {
    "id": "DJI",
    "value": 343625
  },
  {
    "id": "DNK",
    "value": 231180
  },
  {
    "id": "DOM",
    "value": 925410
  },
  {
    "id": "DZA",
    "value": 361795
  },
  {
    "id": "ECU",
    "value": 557070
  },
  {
    "id": "EGY",
    "value": 788239
  },
  {
    "id": "ERI",
    "value": 842903
  },
  {
    "id": "ESP",
    "value": 466295
  },
  {
    "id": "EST",
    "value": 528242
  },
  {
    "id": "ETH",
    "value": 764920
  },
  {
    "id": "FIN",
    "value": 615612
  },
  {
    "id": "FJI",
    "value": 740281
  },
  {
    "id": "FLK",
    "value": 410110
  },
  {
    "id": "FRA",
    "value": 858455
  },
  {
    "id": "GAB",
    "value": 301061
  },
  {
    "id": "GBR",
    "value": 412814
  },
  {
    "id": "GEO",
    "value": 918388
  },
  {
    "id": "GHA",
    "value": 146701
  },
  {
    "id": "GIN",
    "value": 100270
  },
  {
    "id": "GMB",
    "value": 74770
  },
  {
    "id": "GNB",
    "value": 950743
  },
  {
    "id": "GNQ",
    "value": 129334
  },
  {
    "id": "GRC",
    "value": 549853
  },
  {
    "id": "GTM",
    "value": 448582
  },
  {
    "id": "GUY",
    "value": 619775
  },
  {
    "id": "HND",
    "value": 112957
  },
  {
    "id": "HRV",
    "value": 546978
  },
  {
    "id": "HTI",
    "value": 732624
  },
  {
    "id": "HUN",
    "value": 987425
  },
  {
    "id": "IDN",
    "value": 335641
  },
  {
    "id": "IND",
    "value": 941412
  },
  {
    "id": "IRL",
    "value": 873321
  },
  {
    "id": "IRN",
    "value": 975329
  },
  {
    "id": "IRQ",
    "value": 932126
  },
  {
    "id": "ISL",
    "value": 7818
  },
  {
    "id": "ISR",
    "value": 192439
  },
  {
    "id": "ITA",
    "value": 521808
  },
  {
    "id": "JAM",
    "value": 2405
  },
  {
    "id": "JOR",
    "value": 928141
  },
  {
    "id": "JPN",
    "value": 859997
  },
  {
    "id": "KAZ",
    "value": 36425
  },
  {
    "id": "KEN",
    "value": 135107
  },
  {
    "id": "KGZ",
    "value": 972759
  },
  {
    "id": "KHM",
    "value": 115840
  },
  {
    "id": "OSA",
    "value": 703205
  },
  {
    "id": "KWT",
    "value": 457912
  },
  {
    "id": "LAO",
    "value": 144400
  },
  {
    "id": "LBN",
    "value": 252374
  },
  {
    "id": "LBR",
    "value": 353269
  },
  {
    "id": "LBY",
    "value": 253243
  },
  {
    "id": "LKA",
    "value": 196484
  },
  {
    "id": "LSO",
    "value": 799799
  },
  {
    "id": "LTU",
    "value": 247604
  },
  {
    "id": "LUX",
    "value": 863807
  },
  {
    "id": "LVA",
    "value": 302334
  },
  {
    "id": "MAR",
    "value": 700010
  },
  {
    "id": "MDA",
    "value": 908729
  },
  {
    "id": "MDG",
    "value": 920831
  },
  {
    "id": "MEX",
    "value": 476495
  },
  {
    "id": "MKD",
    "value": 417880
  },
  {
    "id": "MLI",
    "value": 447960
  },
  {
    "id": "MMR",
    "value": 994028
  },
  {
    "id": "MNE",
    "value": 695249
  },
  {
    "id": "MNG",
    "value": 408763
  },
  {
    "id": "MOZ",
    "value": 943053
  },
  {
    "id": "MRT",
    "value": 389767
  },
  {
    "id": "MWI",
    "value": 721548
  },
  {
    "id": "MYS",
    "value": 294390
  },
  {
    "id": "NAM",
    "value": 785067
  },
  {
    "id": "NCL",
    "value": 726202
  },
  {
    "id": "NER",
    "value": 419428
  },
  {
    "id": "NGA",
    "value": 595758
  },
  {
    "id": "NIC",
    "value": 823555
  },
  {
    "id": "NLD",
    "value": 74630
  },
  {
    "id": "NOR",
    "value": 925377
  },
  {
    "id": "NPL",
    "value": 106554
  },
  {
    "id": "NZL",
    "value": 433650
  },
  {
    "id": "OMN",
    "value": 225317
  },
  {
    "id": "PAK",
    "value": 326431
  },
  {
    "id": "PAN",
    "value": 837876
  },
  {
    "id": "PER",
    "value": 498953
  },
  {
    "id": "PHL",
    "value": 499335
  },
  {
    "id": "PNG",
    "value": 433178
  },
  {
    "id": "POL",
    "value": 206930
  },
  {
    "id": "PRI",
    "value": 51708
  },
  {
    "id": "PRT",
    "value": 79831
  },
  {
    "id": "PRY",
    "value": 585474
  },
  {
    "id": "QAT",
    "value": 772625
  },
  {
    "id": "ROU",
    "value": 441891
  },
  {
    "id": "RUS",
    "value": 502330
  },
  {
    "id": "RWA",
    "value": 159520
  },
  {
    "id": "ESH",
    "value": 81542
  },
  {
    "id": "SAU",
    "value": 720107
  },
  {
    "id": "SDN",
    "value": 576782
  },
  {
    "id": "SDS",
    "value": 898422
  },
  {
    "id": "SEN",
    "value": 662854
  },
  {
    "id": "SLB",
    "value": 706980
  },
  {
    "id": "SLE",
    "value": 113501
  },
  {
    "id": "SLV",
    "value": 244520
  },
  {
    "id": "ABV",
    "value": 758779
  },
  {
    "id": "SOM",
    "value": 238575
  },
  {
    "id": "SRB",
    "value": 189453
  },
  {
    "id": "SUR",
    "value": 325776
  },
  {
    "id": "SVK",
    "value": 914857
  },
  {
    "id": "SVN",
    "value": 698378
  },
  {
    "id": "SWZ",
    "value": 641048
  },
  {
    "id": "SYR",
    "value": 464703
  },
  {
    "id": "TCD",
    "value": 879135
  },
  {
    "id": "TGO",
    "value": 575504
  },
  {
    "id": "THA",
    "value": 686097
  },
  {
    "id": "TJK",
    "value": 253423
  },
  {
    "id": "TKM",
    "value": 15764
  },
  {
    "id": "TLS",
    "value": 416026
  },
  {
    "id": "TTO",
    "value": 79099
  },
  {
    "id": "TUN",
    "value": 851205
  },
  {
    "id": "TUR",
    "value": 881456
  },
  {
    "id": "TWN",
    "value": 275865
  },
  {
    "id": "TZA",
    "value": 888683
  },
  {
    "id": "UGA",
    "value": 248626
  },
  {
    "id": "UKR",
    "value": 107481
  },
  {
    "id": "URY",
    "value": 360807
  },
  {
    "id": "USA",
    "value": 902559
  },
  {
    "id": "UZB",
    "value": 597042
  },
  {
    "id": "VEN",
    "value": 1743
  },
  {
    "id": "VNM",
    "value": 855805
  },
  {
    "id": "VUT",
    "value": 849289
  },
  {
    "id": "PSE",
    "value": 975744
  },
  {
    "id": "YEM",
    "value": 644213
  },
  {
    "id": "ZAF",
    "value": 453418
  },
  {
    "id": "ZMB",
    "value": 690638
  },
  {
    "id": "ZWE",
    "value": 613810
  },
  {
    "id": "KOR",
    "value": 73400
  }
]